// @flow
module.exports = {
  MAIN: '/',
  KPK: '/kpk',
  OLYMP: '/levels/olympiads',
  GRAD: '/levels/graduate',
  PRIMARY: '/levels/primary',
  BASIC: '/levels/basic',
  IMPROVE: '/levels/improve',
  ENGLISH: '/levels/english',
  PRESCHOOLERS: '/levels/preschoolers',
  ELEMENTARY: '/levels/elementary',
  MIDDLE: '/levels/middle',
  HIGH: '/levels/high',
  COURSE_LANDING: '/courses/:course_id/landing',
  COACH_COURSE_LANDING: '/coach/courses/:course_id/landing',
  AGENT_COURSE_LANDING: '/teacher/courses/:course_id/landing',
  COACH_LANDING: '/coach/landing',
  COACH_LANDING_LEAD: '/coach/landing/lead',
  TEACHER_COACH_LANDING: '/teachers/coach/:id',
  REVIEWS: '/reviews',
  GIFTS: '/game',
  PROMOS: '/promos',
  DEMO_TASK_GENERATOR: '/demo-task-generator',
}
